export default __webpack_public_path__ + "static/media/glp_icon.b4b44485.svg";